<!--
상품 추가
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <div class="uk-modal-header">
                <h4>팝업삭제</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <app-column
                    header="번호"
                    header-size="small"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="80px"
                >
                    {{ popup.id }}
                </app-column>
                <app-column
                    header="시작일"
                    header-size="small"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="80px"
                >
                    {{ popup.started_at }}
                </app-column>
                <app-column
                    header="종료일"
                    header-size="small"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="80px"
                >
                    {{ popup.ended_at }}
                </app-column>

                <app-column
                    header="제목"
                    header-size="small"
                    body-size="medium"
                    header-align="left"
                    body-align="left"
                    horizontal
                    header-width="80px"
                >
                    {{ popup.title }}
                </app-column>


            </div>


            <div class="uk-modal-footer uk-text-right">
                <!-- 컨펌메세지 -->
                <div class="uk-margin-bottom">
                    정말 삭제합니까?
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-danger"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    삭제(완료)
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 팝업
                popup: {},
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param popup_id 팝업ID
             */
            form(popup_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/popups/' + popup_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.popup = response.popup;

                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'delete',
                    url: '/popups/' + this.popup.id,
                    data: {
                        '_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>